<script setup>
import { computed } from 'vue';

const props = defineProps({
    circle: {
        type: Boolean,
        default: false,
    },
    rounded: {
        type: Boolean,
        default: false,
    },
});

const circleClass = computed(() => {
    return {
        'content-circle': props.circle,
        'content-placeholders-is-rounded': props.rounded,
    };
});
</script>

<template>
    <div
        class="content-placeholders-box"
        :class="circleClass"
    />
</template>

<style scoped>
@reference "@css/app.css";

.content-placeholders-box {
    position: relative;
    overflow: hidden;
    min-height: 16px;
    background: #f5f5f5;

    .content-placeholders-is-animated &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        max-width: 1000px;
        height: 100%;
        background: linear-gradient(to right, transparent 0%, #ebebeb 15%, transparent 30%);
        animation-duration: 1.5s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeholdersAnimation;
        animation-timing-function: linear;
    }
}
</style>
